import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { handleNavigate } from "../../hooks/handleNavigate";
import { setAssignment } from "../assignment/assignmentSlice";
import PaperAssignmentModal from "../assignment/components/PaperAssignmentModal";
import { buildTabPath } from "./homeTabs";

// 홈에서 누르는 것들. 미완료 · 완료 과제 목록이 하던 동작을 그대로 옮겼다.
//  - 할 과제: 풀이 화면(/assignment)으로, 지필과제는 올리기 창, 레벨테스트 복습은 ECHO 화면(새 탭)
//  - 끝낸 과제: 학습내역(/review, 새 탭)으로. 틀린 문제가 여기서 보인다. 지필과제는 첨삭 창, 수업 결과는 알림장
const useHomeActions = ({ onPaperModalClose, todoList } = {}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [paperAssignment, setPaperAssignment] = useState(null);

  const goTab = (tabName) => navigate(buildTabPath(tabName, location.search));

  const openTodo = (item) => {
    if (item.isLevelTestReview) {
      window.open(item.start_url, "_blank", "noreferrer");
      return;
    }
    if (item.type === "paper_assignment") {
      setPaperAssignment(item);
      return;
    }
    if (item.type === "class_content") return;
    dispatch(setAssignment(item));
    handleNavigate({ url: "/assignment", params: { id: item.id }, navigate });
  };

  const openFinished = (item) => {
    if (item.type === "paper_assignment") {
      setPaperAssignment(item);
      return;
    }
    if (item.type === "class_content") {
      goTab("paper-assignment");
      return;
    }
    const session = new URLSearchParams(window.location.search).get("session");
    window.open(`/review?id=${item.id}&session=${session}&type=student`, "_blank");
  };

  // 번호만 아는 과제(단어 시험 · 약한 곳의 복습 · 풀이 사진 보너스). 할 과제 목록에 있으면 그것을 열고,
  // 끝낸 것이면 학습내역을, 아니면 풀이 화면으로 간다
  const openById = (assignmentId, type = "", isFinished = false) => {
    if (isFinished || type) {
      openFinished({ id: assignmentId, type });
      return;
    }
    const todoItem = (todoList || []).find((item) => item.id === assignmentId);
    if (todoItem) {
      openTodo(todoItem);
      return;
    }
    handleNavigate({ url: "/assignment", params: { id: assignmentId }, navigate });
  };

  const paperModal = (
    <PaperAssignmentModal
      isOpen={Boolean(paperAssignment)}
      assignment={paperAssignment}
      onClose={() => {
        setPaperAssignment(null);
        if (onPaperModalClose) onPaperModalClose();
      }}
    />
  );

  return { openTodo, openFinished, openById, goTab, paperModal };
};

export default useHomeActions;
